<template>
  <div class="container-main">
    <div class="container-main-header-button">
      <v-btn depressed @click="back">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <span v-if="$route.params.id">
        Редактировать контакт технической поддержки</span>
      <span v-else>Добавить контакт технической поддержки</span>
    </div>
    <v-form ref="formFirst">
      <div class="container-block">
        <div class="container-block-title">Основная информация</div>
        <div>
          <v-text-field label="Название контакта" required type="text" outlined :rules="rules"
            v-model="item.title"></v-text-field>
        </div>
        <div>
          <v-checkbox label="Вид номера телефона +7 (###) ## ####" color="var(--app-dark-blue-1)"
            v-model="phoneNumberStandart" @input="phoneNumberStandart = !phoneNumberStandart"></v-checkbox>
          <v-text-field label="Номер телефона" :type="phoneNumberStandart ? 'text' : 'number'" outlined
            v-mask="phoneNumberStandart ? '+7 (###) ### ####' : ''" :rules="phoneRules"
            v-model="item.phoneNumber"></v-text-field>
        </div>
        <div>
          <v-text-field label="Электронная почта" type="text" outlined :rules="emailRules"
            v-model="item.email"></v-text-field>
        </div>
      </div>
    </v-form>

    <div class="container-block">
      <div class="container-block-title">
        Параметры публикации и отображения
      </div>
      <div class="d-flex align-center">
        <v-switch v-model="item.isHidden" hide-details color="var(--app-green-1)"></v-switch>
        <span class="switch-label">Скрыть из списка технической поддержки (контакт не будет
          отображаться)</span>
      </div>
    </div>

    <div class="container-block-footer-buttons">
      <div>
        <v-btn @click="saveItem" style="width: auto !important" class="button-accept">
          Сохранить
        </v-btn>
      </div>
      <div>
        <v-btn v-if="$route.params.id" @click="dialogDelete = true" outlined style="width: auto !important"
          color="var(--app-red-1)" class="button-accept-outlined">
          Удалить
        </v-btn>
      </div>
    </div>
    <v-dialog width="600px" height="auto" persistent v-model="dialogDelete">
      <v-card>
        <v-card-title class="dialog-title">
          <span class="title">Точно хотите удалить контакт?</span>
          <v-icon @click="dialogDelete = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-actions class="dialog-buttons">
          <v-btn @click="dialogDelete = false" style="width: 120px" outlined color="var(--app-green-1)">
            Нет
          </v-btn>
          <v-btn @click="deleteItem" style="width: 120px" outlined color="var(--app-red-1)">
            Да
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

export default {
  data: () => ({
    item: {
      isHidden: false,
    },
    dialogDelete: false,
    phoneNumberStandart: true,
    rules: [(value) => !!value || "Обязательно к заполнению"],
  }),

  computed: {
    hasContact() {
      return !!this.item.phoneNumber || !!this.item.email;
    },
    phoneRules() {
      const atLeastOne = () =>
        this.hasContact || "Укажите телефон или электронную почту";
      if (this.phoneNumberStandart) {
        return [
          atLeastOne,
          (v) => !v || v.length > 16 || "Номер телефона введен некорректно",
        ];
      }
      return [atLeastOne];
    },
    emailRules() {
      return [
        () => this.hasContact || "Укажите телефон или электронную почту",
        (v) => this.validatorMail(v) || "Адрес почты введен некорректно",
      ];
    },
  },

  methods: {
    back() {
      this.$router.push({ name: "Appeal", params: { selectedTicker: 1 } });
    },
    saveItem() {
      if (this.$refs.formFirst.validate()) {
        const body = {
          title: this.item.title,
          phoneNumber: this.item.phoneNumber,
          email: this.item.email,
          isHidden: this.item.isHidden,
        };
        const config = {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
            "secret-key": this.$store.state.secretKeyCookie,
          },
        };
        const request = this.item.id
          ? this.$axios.patch(
              this.$store.getters.apiAdminPanelV5 +
                "/appeal/support/" +
                this.item.id,
              body,
              config
            )
          : this.$axios.post(
              this.$store.getters.apiAdminPanelV5 + "/appeal/support",
              body,
              config
            );
        request
          .then(() => {
            this.$router.push({ name: "Appeal" });
          })
          .catch((err) => {
            this.$store.commit("errorSet", true);
            this.$store.commit("errorTextSet", err);
          });
      }
    },
    getItem() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV5 +
            "/appeal/support/" +
            this.$route.params.id,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then((res) => {
          this.item = res.data;
          this.phoneNumberStandart = this.item.phoneNumber
            ? this.item.phoneNumber.includes("(")
            : true;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    deleteItem() {
      this.$axios
        .delete(this.$store.getters.apiAdminPanelV2 + "/appeal/support", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            appealSupportId: this.$route.params.id,
          },
        })
        .then(() => {
          this.$router.push({ name: "Appeal" });
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
  },
  created() {
    if (this.$route.params.id) {
      this.getItem();
    }
  },

  watch: {
    newImage() {
      if (this.newImage) {
        this.errImagesMain = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container-main {
  box-sizing: border-box;

  padding: 40px !important;

  .container-main-header-button {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    span {
      font-size: 28px;
      font-weight: 400;
      margin-left: 16px;
    }
  }

  .container-block {
    width: 50%;
    margin-bottom: 20px;

    .container-block-title {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 16px;
    }

    .container-block-gallery-button {
      text-decoration: underline;
      color: #1064dd;
      font-size: 18px;
      font-weight: 400;
      cursor: pointer;
      padding-bottom: 20px;
    }

    .table-img {
      // width: 62px;
      height: 38px;
      object-fit: contain;
    }
  }

  .container-block-footer-buttons {
    display: flex;
    justify-content: space-between;
    width: 50%;
    margin-top: 60px;
  }
}

.dialog-tablet-img {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  img {
    width: 658;
    height: 192;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active до версии 2.1.8 */
  {
  opacity: 0;
}
</style>